var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStats(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1120.856,
    height: 371.617,
    viewBox: "0 0 1120.856 371.617",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ea2047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e61c64",
    stopOpacity: 0.502
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wykres",
    transform: "translate(-36.164 -33.617)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_4_8",
    "data-name": "4,8",
    transform: "translate(129.469 237.706)",
    fill: "#e61c64",
    fontSize: 13,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.575,
    y: 0
  }, "4,8")), /*#__PURE__*/React.createElement("text", {
    id: "_4_6",
    "data-name": "4,6",
    transform: "translate(221.898 237.706)",
    fill: "#2f2e2f",
    fontSize: 13,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.659,
    y: 0
  }, "4,6")), /*#__PURE__*/React.createElement("text", {
    id: "_4_6-2",
    "data-name": "4,6",
    transform: "translate(267.691 237.706)",
    fill: "#2f2e2f",
    fontSize: 13,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.659,
    y: 0
  }, "4,6")), /*#__PURE__*/React.createElement("text", {
    id: "_4_6-3",
    "data-name": "4,6",
    transform: "translate(313.327 237.706)",
    fill: "#2f2e2f",
    fontSize: 13,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.659,
    y: 0
  }, "4,6")), /*#__PURE__*/React.createElement("text", {
    id: "_4_6-4",
    "data-name": "4,6",
    transform: "translate(359.532 237.706)",
    fill: "#2f2e2f",
    fontSize: 13,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.659,
    y: 0
  }, "4,6")), /*#__PURE__*/React.createElement("text", {
    id: "_4_5",
    "data-name": "4,5",
    transform: "translate(405.738 237.706)",
    fill: "#2f2e2f",
    fontSize: 13,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.718,
    y: 0
  }, "4,5")), /*#__PURE__*/React.createElement("text", {
    id: "_4_5-2",
    "data-name": "4,5",
    transform: "translate(451.943 237.706)",
    fill: "#2f2e2f",
    fontSize: 13,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.718,
    y: 0
  }, "4,5")), /*#__PURE__*/React.createElement("text", {
    id: "_4_3",
    "data-name": "4,3",
    transform: "translate(498.749 237.706)",
    fill: "#2f2e2f",
    fontSize: 13,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.347,
    y: 0
  }, "4,3")), /*#__PURE__*/React.createElement("text", {
    id: "_4_3-2",
    "data-name": "4,3",
    transform: "translate(544.961 237.706)",
    fill: "#2f2e2f",
    fontSize: 13,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.347,
    y: 0
  }, "4,3")), /*#__PURE__*/React.createElement("text", {
    id: "_4_2",
    "data-name": "4,2",
    transform: "translate(591.173 237.706)",
    fill: "#2f2e2f",
    fontSize: 13,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.276,
    y: 0
  }, "4,2")), /*#__PURE__*/React.createElement("text", {
    id: "_4_2-2",
    "data-name": "4,2",
    transform: "translate(637.812 237.706)",
    fill: "#2f2e2f",
    fontSize: 13,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.276,
    y: 0
  }, "4,2")), /*#__PURE__*/React.createElement("text", {
    id: "_4_2-3",
    "data-name": "4,2",
    transform: "translate(683.181 237.706)",
    fill: "#2f2e2f",
    fontSize: 13,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.276,
    y: 0
  }, "4,2")), /*#__PURE__*/React.createElement("text", {
    id: "_4_2-4",
    "data-name": "4,2",
    transform: "translate(730.114 237.706)",
    fill: "#2f2e2f",
    fontSize: 13,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.276,
    y: 0
  }, "4,2")), /*#__PURE__*/React.createElement("text", {
    id: "_4_2-5",
    "data-name": "4,2",
    transform: "translate(776.396 237.706)",
    fill: "#2f2e2f",
    fontSize: 13,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.276,
    y: 0
  }, "4,2")), /*#__PURE__*/React.createElement("text", {
    id: "_4_1",
    "data-name": "4,1",
    transform: "translate(822.293 237.706)",
    fill: "#2f2e2f",
    fontSize: 13,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.742,
    y: 0
  }, "4,1")), /*#__PURE__*/React.createElement("text", {
    id: "_4_1-2",
    "data-name": "4,1",
    transform: "translate(868.427 237.706)",
    fill: "#2f2e2f",
    fontSize: 13,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.742,
    y: 0
  }, "4,1")), /*#__PURE__*/React.createElement("text", {
    id: "_3_9",
    "data-name": "3,9",
    transform: "translate(914.922 237.706)",
    fill: "#2f2e2f",
    fontSize: 13,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.185,
    y: 0
  }, "3,9")), /*#__PURE__*/React.createElement("text", {
    id: "_3_8",
    "data-name": "3,8",
    transform: "translate(960.574 237.706)",
    fill: "#2f2e2f",
    fontSize: 13,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.087,
    y: 0
  }, "3,8")), /*#__PURE__*/React.createElement("text", {
    id: "_3_6",
    "data-name": "3,6",
    transform: "translate(1007.07 237.706)",
    fill: "#2f2e2f",
    fontSize: 13,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.172,
    y: 0
  }, "3,6")), /*#__PURE__*/React.createElement("text", {
    id: "_3_6-2",
    "data-name": "3,6",
    transform: "translate(1052.565 236.706)",
    fill: "#2f2e2f",
    fontSize: 12,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.466,
    y: 0
  }, "3,6")), /*#__PURE__*/React.createElement("text", {
    id: "_3_4",
    "data-name": "3,4",
    transform: "translate(1100.06 237.706)",
    fill: "#2f2e2f",
    fontSize: 13,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.347,
    y: 0
  }, "3,4")), /*#__PURE__*/React.createElement("text", {
    id: "_3_3",
    "data-name": "3,3",
    transform: "translate(1146.555 237.706)",
    fill: "#2f2e2f",
    fontSize: 13,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.86,
    y: 0
  }, "3,3")), /*#__PURE__*/React.createElement("g", {
    id: "_2796285455648",
    transform: "translate(36.164 254.668)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Sarigato_Sataku",
    "data-name": "Sarigato/Sataku",
    transform: "translate(91.217 14.133) rotate(-45)",
    fill: "#2f2e2f",
    fontSize: 13,
    fontFamily: "Syne-Bold, Syne",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -116.896,
    y: 0
  }, "Sarigato/Sataku"))), /*#__PURE__*/React.createElement("text", {
    id: "Tri-Table_",
    "data-name": "Tri-Table ",
    transform: "translate(226.353 264.805) rotate(-45)",
    fill: "#2f2e2f",
    fontSize: 11,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -44.077,
    y: 0
  }, "Tri-Table ")), /*#__PURE__*/React.createElement("text", {
    id: "Grupa_Olx_",
    "data-name": "Grupa Olx ",
    transform: "translate(276.36 265.576) rotate(-45)",
    fill: "#2f2e2f",
    fontSize: 11,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -51.073,
    y: 0
  }, "Grupa Olx ")), /*#__PURE__*/React.createElement("text", {
    id: "Biuro_Reklamy_Grupa_Wyborcza",
    "data-name": "Biuro Reklamy Grupa Wyborcza",
    transform: "translate(318.719 266.608) rotate(-45)",
    fill: "#2f2e2f",
    fontSize: 11,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -155.518,
    y: 0
  }, "Biuro Reklamy Grupa Wyborcza")), /*#__PURE__*/React.createElement("text", {
    id: "Biuro_Reklamy_Gazeta.pl",
    "data-name": "Biuro Reklamy Gazeta.pl",
    transform: "translate(361.877 267.124) rotate(-45)",
    fill: "#2f2e2f",
    fontSize: 11,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -119.174,
    y: 0
  }, "Biuro Reklamy Gazeta.pl")), /*#__PURE__*/React.createElement("text", {
    id: "Mediafarm",
    transform: "translate(410.411 264.805) rotate(-45)",
    fill: "#2f2e2f",
    fontSize: 11,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -54.098,
    y: 0
  }, "Mediafarm")), /*#__PURE__*/React.createElement("text", {
    id: "RMF_Digital",
    "data-name": "RMF Digital",
    transform: "translate(456.109 265.322) rotate(-45)",
    fill: "#2f2e2f",
    fontSize: 11,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -56.254,
    y: 0
  }, "RMF Digital")), /*#__PURE__*/React.createElement("text", {
    id: "TikTok",
    transform: "translate(503.995 264.805) rotate(-45)",
    fill: "#2f2e2f",
    fontSize: 11,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -31.152,
    y: 0
  }, "TikTok")), /*#__PURE__*/React.createElement("text", {
    id: "TVN_Media",
    "data-name": "TVN Media",
    transform: "translate(549.593 266.577) rotate(-45)",
    fill: "#2f2e2f",
    fontSize: 11,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -53.812,
    y: 0
  }, "TVN Media")), /*#__PURE__*/React.createElement("text", {
    id: "Proxi.cloud",
    transform: "translate(590.711 265.433) rotate(-45)",
    fill: "#2f2e2f",
    fontSize: 11,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -54.087,
    y: 0
  }, "Proxi.cloud")), /*#__PURE__*/React.createElement("text", {
    id: "Grupa_Eurozet",
    "data-name": "Grupa Eurozet",
    transform: "translate(637.519 263.884) rotate(-45)",
    fill: "#2f2e2f",
    fontSize: 11,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -69.927,
    y: 0
  }, "Grupa Eurozet")), /*#__PURE__*/React.createElement("text", {
    id: "IDMnet",
    transform: "translate(687.424 267.387) rotate(-45)",
    fill: "#2f2e2f",
    fontSize: 11,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -36.091,
    y: 0
  }, "IDMnet")), /*#__PURE__*/React.createElement("text", {
    id: "Biuro_Reklamy_Ringier_Axel_Springer_Polska",
    "data-name": "Biuro Reklamy Ringier Axel Springer Polska",
    transform: "translate(727.536 265.992) rotate(-45)",
    fill: "#2f2e2f",
    fontSize: 11,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -105.952,
    y: 0
  }, "Biuro Reklamy Ringier"), /*#__PURE__*/React.createElement("tspan", {
    x: -96.877,
    y: 13
  }, "Axel Springer Polska")), /*#__PURE__*/React.createElement("text", {
    id: "Wirtualna_Polska",
    "data-name": "Wirtualna Polska",
    transform: "translate(782.908 264.551) rotate(-45)",
    fill: "#2f2e2f",
    fontSize: 11,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -82.676,
    y: 0
  }, "Wirtualna Polska")), /*#__PURE__*/React.createElement("text", {
    id: "Biuro_Reklamy_TVP",
    "data-name": "Biuro Reklamy TVP",
    transform: "translate(827.871 265.028) rotate(-45)",
    fill: "#2f2e2f",
    fontSize: 11,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -91.531,
    y: 0
  }, "Biuro Reklamy TVP")), /*#__PURE__*/React.createElement("text", {
    id: "Biuro_Reklamy_Internet_Programmatic_Performance_-_Grupa_ZPR_Media",
    "data-name": "Biuro Reklamy Internet Programmatic /Performance - Grupa ZPR Media",
    transform: "translate(868.3 263.813) rotate(-45)",
    fill: "#2f2e2f",
    fontSize: 11,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -183.469,
    y: 0
  }, "Biuro Reklamy Internet Programmatic"), /*#__PURE__*/React.createElement("tspan", {
    x: -164.054,
    y: 13
  }, "/Performance - Grupa ZPR Media")), /*#__PURE__*/React.createElement("text", {
    id: "Polska_Press_Group",
    "data-name": "Polska Press Group",
    transform: "translate(922.241 263.813) rotate(-45)",
    fill: "#2f2e2f",
    fontSize: 11,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -92.345,
    y: 0
  }, "Polska Press Group")), /*#__PURE__*/React.createElement("text", {
    id: "Grupa_Allegro",
    "data-name": "Grupa Allegro",
    transform: "translate(967.56 264.988) rotate(-45)",
    fill: "#2f2e2f",
    fontSize: 11,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -65.978,
    y: 0
  }, "Grupa Allegro")), /*#__PURE__*/React.createElement("text", {
    id: "Polsat_Media",
    "data-name": "Polsat Media",
    transform: "translate(1008.864 258.86) rotate(-45)",
    fill: "#2f2e2f",
    fontSize: 11,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -63.184,
    y: 0
  }, "Polsat Media")), /*#__PURE__*/React.createElement("text", {
    id: "Aleph",
    transform: "translate(1058.112 267.426) rotate(-45)",
    fill: "#2f2e2f",
    fontSize: 11,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -27.72,
    y: 0
  }, "Aleph")), /*#__PURE__*/React.createElement("text", {
    id: "Meta",
    transform: "translate(1106.267 265.766) rotate(-45)",
    fill: "#2f2e2f",
    fontSize: 11,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -25.498,
    y: 0
  }, "Meta")), /*#__PURE__*/React.createElement("text", {
    id: "Google_i_YouTube",
    "data-name": "Google i YouTube",
    transform: "translate(1154.279 264.249) rotate(-45)",
    fill: "#2f2e2f",
    fontSize: 11,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -83.116,
    y: 0
  }, "Google i YouTube")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_108",
    "data-name": "Rectangle 108",
    width: 20.804,
    height: 174.875,
    transform: "translate(119.808 33.617)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_156",
    "data-name": "Rectangle 156",
    width: 20.804,
    height: 171.451,
    transform: "translate(165.808 37.041)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_110",
    "data-name": "Rectangle 110",
    width: 20.806,
    height: 167.803,
    transform: "translate(211.808 40.689)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    "data-name": "Rectangle 111",
    width: 20.806,
    height: 167.803,
    transform: "translate(258.169 40.689)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112",
    "data-name": "Rectangle 112",
    width: 20.804,
    height: 167.803,
    transform: "translate(304.383 40.689)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113",
    "data-name": "Rectangle 113",
    width: 20.806,
    height: 167.803,
    transform: "translate(350.595 40.689)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 20.806,
    height: 164.155,
    transform: "translate(396.807 44.337)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_115",
    "data-name": "Rectangle 115",
    width: 20.806,
    height: 164.155,
    transform: "translate(443.021 44.337)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_116",
    "data-name": "Rectangle 116",
    width: 20.806,
    height: 156.859,
    transform: "translate(489.234 51.633)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_117",
    "data-name": "Rectangle 117",
    width: 20.806,
    height: 156.859,
    transform: "translate(535.446 51.633)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_118",
    "data-name": "Rectangle 118",
    width: 20.806,
    height: 153.212,
    transform: "translate(581.808 55.281)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_119",
    "data-name": "Rectangle 119",
    width: 20.806,
    height: 153.212,
    transform: "translate(627.808 55.281)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_120",
    "data-name": "Rectangle 120",
    width: 20.806,
    height: 153.212,
    transform: "translate(674.086 55.281)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_121",
    "data-name": "Rectangle 121",
    width: 20.806,
    height: 153.212,
    transform: "translate(720.296 55.281)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_122",
    "data-name": "Rectangle 122",
    width: 20.804,
    height: 153.211,
    transform: "translate(766.513 55.281)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 20.804,
    height: 149.564,
    transform: "translate(812.728 58.928)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    width: 20.806,
    height: 149.564,
    transform: "translate(858.808 58.928)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_125",
    "data-name": "Rectangle 125",
    width: 20.806,
    height: 142.267,
    transform: "translate(905.151 66.225)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    width: 20.806,
    height: 138.619,
    transform: "translate(951.363 69.873)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    width: 20.806,
    height: 131.324,
    transform: "translate(997.575 77.169)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    width: 20.806,
    height: 131.324,
    transform: "translate(1043.787 77.169)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    width: 20.806,
    height: 124.253,
    transform: "translate(1090.002 84.465)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_130",
    "data-name": "Rectangle 130",
    width: 20.806,
    height: 120.379,
    transform: "translate(1136.214 88.113)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_4_7",
    "data-name": "4,7",
    transform: "translate(175.808 237.707)",
    fill: "#2f2e2f",
    fontSize: 13,
    fontFamily: "Syne-SemiBold, Syne",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.347,
    y: 0
  }, "4,7")), /*#__PURE__*/React.createElement("text", {
    id: "YOC_Poland_",
    "data-name": "YOC Poland ",
    transform: "translate(174.088 267.387) rotate(-45)",
    fill: "#2f2e2f",
    fontSize: 11,
    fontFamily: "Syne-Regular, Syne"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -60.335,
    y: 0
  }, "YOC Poland ")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats);
export default __webpack_public_path__ + "static/media/stats.f88c7fc4bcedd1c5f24482347c8a639c.svg";
export { ForwardRef as ReactComponent };